module.exports = __webpack_public_path__ + "static/post-banner-532c41d415f9e3a4c78c887badb3157f.jpg";